module.exports = __webpack_public_path__ + "img/monitoring-car-green.41f6152d.svg";